import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const LinkSpareDialog = ({
  openDialog,
  handleClose,
  register,
  handleSubmit,
  errors,
  getSpareByArticleCode,
  setArticleCode,
  formData,
  onLinkSpareWithModelSubmit,
  setValue,
}) => {
  const [disableSearchButton, setDisbleSearchButton] = useState(true);

  useEffect(() => {
    setValue("description", formData.description);
    setValue("partName", formData.partName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setDisbleSearchButton(true)
  }, [formData]); 

  return (
    <>
      <Dialog open={openDialog} onClose={handleClose} fullWidth={1}
        maxWidth={"xs"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>Link Spare</b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 1 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={1}
                    justifyContent="left"
                    alignItems="start"
                  >
                    <Grid item xs={8} sx={{ mb: 1 }}>
                      <TextField
                        className="stepperFormInput"
                        name="code"
                        label="Article Code"
                        placeholder="Enter article code"
                        fullWidth
                        required
                        size="small"
                        maxLength={9}
                        autoComplete="off"
                        {...register("code", {
                          required: "This field is required",
                          pattern: {
                            value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                            message: "Field can not start with special characters",
                          },
                          maxLength: {
                            value: 20,
                            message: "Max length is 20 only",
                          },
                          minLength: {
                            value: 3,
                            message: "Min length is 3",       
                          },
                        })}
                        error={Boolean(errors?.code?.message)}
                        helperText={errors?.code?.message}
                        onChange={(e) => {
                          setArticleCode(e.target.value);
                          if (e.target.value.length <= 2) {
                            setDisbleSearchButton(true);
                          }
                          else if (e.target.value.length >= 21) {
                            setDisbleSearchButton(true);
                          }
                          else if (e.target.value.length >= 3) {
                            setDisbleSearchButton(false);
                          }
                          else{
                            setDisbleSearchButton(true);
                          }
                        }}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("code", str.trim());
                         
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} sx={{ mb: 1 }}>
                      <Button
                        variant="contained"
                        size="medium"
                        onClick={getSpareByArticleCode}
                        disabled={disableSearchButton}
                      >
                        Search Spare
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ mb: 1 }}>
                    <TextField
                      className="stepperFormInput"
                      label="Spare Article Description"
                      name="description"
                      fullWidth
                      required
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      disabled
                      defaultValue={formData?.description ?? ""}
                      autoComplete="off"
                      {...register("description", { required: true })}
                      error={Boolean(errors?.description)}
                      helperText={errors?.description?.message}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="stepperFormInput"
                      label="Part Name"
                      name="partName"
                      fullWidth
                      required
                      disabled
                      defaultValue={formData?.partName ?? ""}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      autoComplete="off"
                      {...register("partName", { required: true })}
                      error={Boolean(errors?.partName)}
                      helperText={errors?.partName?.message}
                    />
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 1, pl: 37 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onLinkSpareWithModelSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default LinkSpareDialog;
